module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-sidebar"
  }, [_c('div', {
    staticClass: "alert-sidebar-header"
  }, [_vm._v("ALERT CATEGORIES")]), _vm._v(" "), _c('div', {
    staticClass: "alert-sidebar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "alert-sidebar-item",
    class: {
      active: _vm.activeCategory === '' || _vm.activeCategory === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.selectCategory('all')
      }
    }
  }, [_c('i', {
    staticClass: "bell icon alert-sidebar-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "alert-sidebar-name"
  }, [_vm._v("All Alerts")]), _vm._v(" "), _c('span', {
    class: ['alert-sidebar-count', 'notranslate', _vm.totalCountClass],
    attrs: {
      "translate": "no"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.totalCount) + "\n    ")])]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "alert-sidebar-group"
    }, [_c('div', {
      staticClass: "alert-sidebar-group-header"
    }, [_c('span', {
      staticClass: "alert-sidebar-group-name"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _vm._l((group.badges), function(badge) {
      return _c('span', {
        key: badge.text,
        class: ['alert-sidebar-badge', 'badge-' + badge.color]
      }, [_vm._v("\n        " + _vm._s(badge.text) + "\n      ")])
    })], 2), _vm._v(" "), _vm._l((group.items), function(item) {
      return _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isVisible(item)),
          expression: "isVisible(item)"
        }],
        key: item.id,
        class: ['alert-sidebar-item', {
          active: _vm.activeCategory === item.id
        }],
        on: {
          "click": function($event) {
            return _vm.selectCategory(item.id)
          }
        }
      }, [_c('i', {
        class: item.icon + ' icon alert-sidebar-icon'
      }), _vm._v(" "), _c('span', {
        staticClass: "alert-sidebar-name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        class: ['alert-sidebar-count', 'notranslate', _vm.countClass(item.id)],
        attrs: {
          "translate": "no"
        }
      }, [_vm._v("\n        " + _vm._s(_vm.displayCount(item.id)) + "\n      ")])])
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12838b5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/AlertCategoriesSidebar.vue
// module id = 726
// module chunks = 2